import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { isMetaPixelPublicPath, trackMetaPageView } from '@/lib/meta-pixel';

/** PageView Meta Pixel sur les navigations SPA (pages publiques uniquement). */
export function MetaPixelTracker() {
  const location = useLocation();

  useEffect(() => {
    if (!isMetaPixelPublicPath(location.pathname)) return;
    trackMetaPageView();
  }, [location.pathname, location.search]);

  return null;
}
